<template>
  <v-container>
    <v-layout>
      <v-container>
        <v-card>
          <v-toolbar
          card
          color="#0C116F">
          <v-toolbar-title class="white--text">Search Update</v-toolbar-title>
          </v-toolbar>

          <v-card-title>Can be directly downloaded from S3. Every monday new searches get uploaded.</v-card-title>

          <v-card-text>


          <v-card-text>
        <v-layout row align-center>
          <v-flex xs2>
            <v-text-field
              v-model="newSearchesWeeks"
              label="New Searches (weeks)"
              type="number"
              min="0"
              max="52"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs10>
            <v-slider
              v-model="newSearchesWeeks"
              min="0"
              max="52"
              step="1"
              thumb-label
              ticks
            ></v-slider>
          </v-flex>
        </v-layout>
        <v-layout row align-center>
          <v-flex xs2>
            <v-text-field
              v-model="updatedSearchesWeeks"
              label="Updated Searches (weeks)"
              type="number"
              min="0"
              max="52"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs10>
            <v-slider
              v-model="updatedSearchesWeeks"
              min="0"
              max="52"
              step="1"
              thumb-label
              ticks
            ></v-slider>
          </v-flex>
        </v-layout>
        <v-btn @click="downloadcsv"
               color="green darken-1"
               class="white--text"
               large>
          Download Search Update
        </v-btn>
        <v-btn @click="cancel">Cancel</v-btn>

        <v-divider class="my-2"></v-divider>
        <v-alert
        :value="true" 
        type="info">
          Here you can download the search updates. Use the sliders above to specify the number of past weeks for new and updated searches. The .txt file will be generated and downloaded as a .zip.
          
        </v-alert>
      </v-card-text>
          </v-card-text>
         <v-snackbar
              v-model="snackbar"
              :multi-line="true"
              :top="true"
              multi-line
              :timeout="60000"              
              :vertical="true"
              :auto-height="true"
            >
            <a v-bind:href="text">{{text}}</a>
              <v-btn
                color="pink"
                flat
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </v-snackbar>          
          
        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import Config from '../utils/Config'
import AmplifyStore from '../store/store';
export default {
  data () {
    return {
      url: '',
      text: '',
      snackbar: false,
      newSearchesWeeks: 1,
      updatedSearchesWeeks: 1,
      url_all: 'https://s3.amazonaws.com/beas-d2r-entity-mngmnt-api-exportbucket-1wbv7xeei6kor/exported-entities.csv'
    }
  },
  mounted() {
    this.$emit('TriggerLoading', false)
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    downloadcsv() {
      this.$emit('TriggerLoading', true)
      axios
        .get(`${Config.API_URL}/searchupdatedownload`, {
          params: {
            new_searches_weeks: this.newSearchesWeeks,
            updated_searches_weeks: this.updatedSearchesWeeks
          }
        })
        .then(response => {
          console.info(response.data)
          this.text = response.data.url
          this.snackbar = true
          this.$emit('TriggerLoading', false)
        })
        .catch(error => {
          this.$emit('TriggerLoading', false)
        })
    }
  }
}
</script>
